export default [
  {
    path: "/media-release-unsubscribed-recipients",
    component: () => import("pages/MediaReleaseUnsubscribedRecipients.vue"),
  },
];
